import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestScannerResultMarkupGet = {
    path: "/scanner/result/markup/:id",
    method: RouteHttpVerb.GET
};
